import {Workspace} from "../../API";

import {queryGqlApi} from "../../graphql/queryGqlApi";
import {logErrorToSentry} from "../../utils/errors/logErrorToSentry";
import {makeApiServerRequest} from "@stores/serverConnection/makeApiServerRequest";


import {deleteWorkspace as deleteWorkspaceGQL} from "../../graphql/mutations";
import {PM_ACTIONS} from "@stores/serverConnection/types";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";
import {UserSessionState} from "@stores/UserSessionState";


export async function deleteWorkspace(
    dataClientService: IDataClientService,
    authService: IAuthService,
    userState: UserSessionState,
    workspace: Workspace
) {
    try {
        await queryGqlApi(
            deleteWorkspaceGQL,
            {
                input: {
                    id: workspace.id,
                    _version: workspace._version,
                }
            },
            dataClientService,
            authService,
            'main'
        )
        makeApiServerRequest(
            userState.wsServerConnection,
            'ws/del',
            {
                wsId: workspace.id,
                a: PM_ACTIONS.WORKSPACE_DEL,
            },
        )
    } catch (error: any) {
        logErrorToSentry(error)
    }
}
